import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-06-05'
        tag='Grailed'
        title='How to Earn More With Grailed Seller Initiated Offers'
      >
        <h3>What is a Seller Initiated offer?</h3>
        <p>
          With seller-initiated offers, a seller can make an offer to the last 100 people who have favorited their
          listing. Buyers will then receive an email with the details of the offer. By using this, sellers can maximize
          their opportunities to make a sale by utilizing the seller-initiated offer function.{' '}
        </p>

        <h3>Seller initiated Offer and Binding Offer</h3>
        <p>
          The main difference between a seller-initiated offer and a binding offer is where the offer comes from. A
          binding offer is when a buyer makes an offer to the seller, and once the seller agrees to the offer, the
          payment is processed, the order is shipped, and the transaction is final.
        </p>
        <p>
          However, it is important to note that you only have 24 hours to accept or make a counteroffer after receiving
          a binding offer. The binding offer will expire in 24 hours. So be sure that you don't miss out because once a
          binding offer has passed its expiration date, it is instantly void and cannot be accepted.
        </p>
        <p>
          On the other hand, the seller-initiated offer is, as the name implies, the seller creating the offer for the
          buyer. For the seller-initiated offers, the buyer can either purchase, send a counteroffer, or send a message
          once they receive an offer from the seller. They work similarly to counteroffers, except that there is no
          initial offer from the buyer.
        </p>

        <h3>How to send a Seller Initiated Offer </h3>
        <p>
          You can send a seller-initiated offer by simply going to <strong>My Items</strong> or the item listing page in
          your browser. Alternatively, you can also tap the <strong>Sell</strong> button, then <strong>My Items</strong>{' '}
          on the app. You'll notice a <strong>Send Offer</strong> button on each of your ads. When you press the button,
          a window will appear where you can enter your offer price.
        </p>

        <h3>Guidelines when initiating an offer</h3>
        <p>
          Take note that when initiating an offer to a buyer, the offered price always excludes shipping, and it must be
          an offer of at least a 10% discount on the current price of the item.{' '}
        </p>
        <p>
          If you've sent the buyer an offer before, then the new offer must be at least 10% lower than the previous
          offer. Be sure that you use your initiated offers wisely, as you can only send up to 2 offers per listing and
          can only send an offer on a listing every 24 hours.{' '}
        </p>
        <p>
          This ensures that the buyers aren't spammed with too many offers, so sellers are limited to sending only ten
          offers per day. And one of the most important things to note is that if you put out a seller-initiated offer
          and then later lower the price of your listing, buyers who received your offer will see the original price and
          not the new price.
        </p>

        <h3>Get things done effectively to maximize earning potential.</h3>
        <p>
          Increasing sales is every seller's goal. Aside from creating offers to potential buyers, you can also venture
          into different marketplaces —increasing your items' exposure and ultimately getting more conversions from
          shoppers outside Grailed.{' '}
        </p>
        <p>
          Subscribing to an automation service like OneShop can help you crosslist across multiple marketplaces with an
          automatic delisting feature. This allows you to save time by quickly creating drafts that can be cross-listed
          on different platforms such as Poshmark, Mercari, Depop, Tradesy, eBay, and more marketplaces soon.
        </p>
        <p>
          With OneShop, you can also enjoy features that easily track sales and set new sales objectives while quickly
          ordering supplies and scheduling package pickups with no problem.{' '}
        </p>
        <p>
          Take advantage of these features and more by <a href='https://tools.oneshop.com/signup'>signing up now</a>.
          Set up your account in less than three minutes, and enjoy a 7-day free trial!{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
